import axios from "axios";
import React from "react";
import { jsonHeader } from '../util/GeneralUtil'
const apiUrl = process.env.REACT_APP_API_URL;

async function getSuperMaster(payload) {
    const result = await axios.post(apiUrl + "/admin/dropdown/getsupermaster",payload,{
         headers: jsonHeader}
    );
    return result.data || [];
}

async function getAdmin(payload) {
    const result = await axios.post(apiUrl + "/admin/dropdown/getadmins",payload,{
         headers: jsonHeader}
    );
    return result.data || [];
}

async function getSubBroker(payload) {
    const result = await axios.post(apiUrl + "/admin/dropdown/getsubbrokers",payload,{
         headers: jsonHeader}
    );
    return result.data || [];
}

async function getUsers(payload) {
    const result = await axios.post(apiUrl + "/admin/getusers",payload,{
         headers: jsonHeader}
    );
    return result.data || [];
}

async function getBrokers(payload) {
    const result = await axios.post(apiUrl + "/admin/dropdown/getbrokers",payload,{
         headers: jsonHeader}
    );
    return result.data || [];
}


export const ComponentsService = {
    getSuperMaster,
    getAdmin,
    getSubBroker,
    getUsers,
    getBrokers,
}